import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-page-headline',
    templateUrl: './page-headline.component.html',
    styleUrls: ['./page-headline.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false,
})
export class PageHeadlineComponent {

    constructor() {
    }
}
